import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMarketNews } from "../../redux/action/newsAction";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTitle } from '../../context/TitleProvider';

export const News = () => {
  const {setTitle} = useTitle()
       const dispatch = useDispatch()
       useEffect($=> {
           setTitle("News")
           dispatch(fetchMarketNews())
       }, [dispatch, setTitle] )
       const {  data } = useSelector(state => ({
        data: state.newsState.data
      }))
 
      return <>
      <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
      {
         data?.map(el=>{
               return  <Grid key={el.url} item xs={4}>
               <Card sx={{ maxWidth: 400, minHeight: 400, maxHeight: "auto"}}>
               <CardMedia
                 component="img"
                 alt={el.title}
                 height="140"
                 image={el.urlToImage}
               />
             
               <CardContent>
                 <Typography gutterBottom variant="h5" component="div">
                 {el?.title?.slice(0,100) + "..."}
                 </Typography>
                 <Typography variant="body2" color="text.secondary">
                  {el?.description?.slice(0,100) + "..."}
                 </Typography>
               </CardContent>
               <CardActions>
                 <a href={el.url}><Button size="small">Learn More</Button></a>
               </CardActions>
               </Card>
               </Grid>
         })
      }
        </Grid>
    </Box>
      </>

}




